<template>
  <div class="average-score">
    <span><slot></slot></span>
    <span>{{ score }}</span>
  </div>
</template>

<script>
	export default {
		name: "em-asset-average-score",
    props: {
		  score: {
        required: true
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/averageScore.vue